const TOP = 20;
const GAP = 16;

let users = 0;
let stop = null;

function restack() {
    let top = TOP;
    document.querySelectorAll('body > .el-message').forEach((el) => {
        if (el.style.display === 'none') {
            return;
        }
        const next = `${top}px`;
        if (el.style.top !== next) { // our own write re-fires the style observer
            el.style.setProperty('top', next);
        }
        top += el.offsetHeight + GAP;
    });
}

// Element 1.x only renders its X when showClose is set; stacked toasts need a way to dismiss (CTM-1525).
function makeClosable(node) {
    // eslint-disable-next-line no-underscore-dangle
    let vm = node.__vue__;
    while (vm && typeof vm.close !== 'function') { // after a re-render __vue__ is Element's inner <transition>
        vm = vm.$parent;
    }
    if (!vm) {
        return;
    }
    if (node.querySelector('.link-success-alert')) { // buildFlashMessage back-link toast (crm.js), X would cover it
        return;
    }
    vm.showClose = true;
    vm.$nextTick(() => {
        const btn = node.querySelector('.el-message__closeBtn');
        if (!btn || btn.hasAttribute('role')) {
            return;
        }
        btn.setAttribute('role', 'button');
        btn.setAttribute('tabindex', '0');
        btn.setAttribute('aria-label', 'Close');
        btn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                vm.close();
            }
        });
    });
}

function start() {
    const toastObserver = new MutationObserver(restack);
    const watch = (node) => {
        if (node.classList && node.classList.contains('el-message')) {
            toastObserver.observe(node, { attributes: true, attributeFilter: ['style'] });
            makeClosable(node);
        }
    };
    const bodyObserver = new MutationObserver((mutations) => {
        mutations.forEach(({ addedNodes }) => addedNodes.forEach(watch));
        restack();
    });
    document.body.classList.add('stack-messages');
    document.querySelectorAll('body > .el-message').forEach(watch);
    bodyObserver.observe(document.body, { childList: true });
    window.addEventListener('resize', restack);
    restack();
    stop = () => {
        bodyObserver.disconnect();
        toastObserver.disconnect();
        window.removeEventListener('resize', restack);
        document.body.classList.remove('stack-messages');
    };
}

export const isEmailPage = (pathname) => /^\/email(\/|$)/.test(pathname);

// Element UI 1.x pins every Message at top:20px, so concurrent toasts overlap (CTM-1525).
export default function stackMessages() {
    users += 1;
    if (users === 1) {
        start();
    }
    let released = false;
    return () => {
        if (released) {
            return;
        }
        released = true;
        users -= 1;
        if (users === 0) {
            stop();
        }
    };
}
